(() => {
  const initPage = (scope = document) => {
    scope.querySelectorAll('.yoclez-page__content .yocles-page-hero').forEach((legacyHero) => legacyHero.remove());
  };

  const initProduct = (scope = document) => {
    scope.querySelectorAll('[data-yoclez-product]').forEach((section) => {
      if (section.dataset.yoclezInitialized === 'true') return;
      section.dataset.yoclezInitialized = 'true';

      const mainImage = section.querySelector('[data-gallery-main]');
      section.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (!mainImage) return;
          mainImage.src = thumb.dataset.imageSrc;
          mainImage.removeAttribute('srcset');
          mainImage.alt = thumb.dataset.imageAlt || '';
          section.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });

      const productForm = section.querySelector('.yoclez-product__form');
      const stickyCart = section.querySelector('[data-sticky-cart]');
      const updateStickyCart = () => {
        if (!productForm || !stickyCart) return;
        stickyCart.classList.toggle('is-visible', productForm.getBoundingClientRect().bottom < 0);
      };
      updateStickyCart();
      addEventListener('scroll', updateStickyCart, { passive: true });
      addEventListener('resize', updateStickyCart);

      const variantSelect = section.querySelector('[data-variant-select]');
      if (!variantSelect) return;
      const price = section.querySelector('[data-product-price]');
      const stock = section.querySelector('[data-product-stock]');
      const submit = section.querySelector('[data-add-to-cart]');
      const stickySubmit = section.querySelector('[data-sticky-submit]');
      const stickyPrice = section.querySelector('[data-sticky-price]');

      variantSelect.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        const available = option.dataset.available === 'true';
        const compare = option.dataset.comparePrice;
        price.innerHTML = `<span class="yoclez-product__price-current">${option.dataset.price}</span>${compare ? `<s>${compare}</s><span class="yoclez-sale-badge">Sale</span>` : ''}`;
        stickyPrice.textContent = option.dataset.price;
        stock.textContent = available ? 'In stock' : 'Sold out';
        stock.classList.toggle('is-sold-out', !available);
        [submit, stickySubmit].forEach((button) => {
          if (!button) return;
          button.disabled = !available;
          button.textContent = available ? 'Add to cart' : 'Sold out';
        });
      });
    });
  };

  const init = (scope = document) => {
    initPage(scope);
    initProduct(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
